/* eslint-disable */
// Admin audit logs handler
import { db } from "../../firebase-config";
import { ref as dbRef, push } from "firebase/database";
import CryptoJS from "crypto-js";

//deepaaudit logs - Helper functions for encryption/decryption
// Function to check if a string is base64 encoded
const isBase64 = (str) => {
  try {
    return btoa(atob(str)) === str;
  } catch (err) {
    return false;
  }
};

// Function to encrypt data using CryptoJS and secret key
const encrypt = (data) => {
  if (!data) return data;
  const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
  return CryptoJS.AES.encrypt(data, secretKey).toString();
};

// Function to decrypt data using CryptoJS and secret key
const decrypt = (encryptedData) => {
  try {
    if (!encryptedData) return encryptedData;
    if (!isBase64(encryptedData)) {
      return encryptedData;
    }
    const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted || encryptedData;
  } catch (error) {
    console.warn("Error decrypting data:", error);
    return encryptedData;
  }
};

// Admin bulk assignment handler
export async function logBulkAssignmentAdmin({
  assignedBy = "Unknown Admin",
  assignedDoctor = "Unknown Doctor",
  patientCount = 0,
  patientIds = [],
  patientNames = [],
  success = false,
  failureReason = "",
  assignmentType = "bulk", // "bulk" or "individual"
}) {
  try {
    const logRef = dbRef(db, "audit_logs/UserManagement/Admin_logs/Bulk_Assignment_Admin");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent || "Unknown";
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success
        ? `Bulk assignment of ${patientCount} patients to doctor by admin`
        : "Bulk assignment failed by admin",
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown",
    };

    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}
    
    // Encrypt all patient IDs
    const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
    const encryptedPatientIds = patientIds.filter(id => id).map(id => 
      CryptoJS.AES.encrypt(id.toString(), secretKey).toString()
    );
    
    const entry = {
      event_type: success ? "bulk_assignment_admin" : "bulk_assignment_failed_admin",
      assigned_by: assignedBy || "Unknown Admin",
      assigned_doctor: assignedDoctor || "Unknown Doctor",
      patient_count: patientCount || 0,
      assignment_type: assignmentType || "bulk",
      success: Boolean(success),
      timestamp,
      details,
      patient_ids_encrypted: encryptedPatientIds,
      patient_names: patientNames.filter(name => name),
      ...((!success && failureReason) && { failure_reason: failureReason }),
    };
    
    await push(logRef, entry);
    console.log("Admin bulk assignment audit log written.");
  } catch (err) {
    console.error("Failed to write admin bulk assignment audit log:", err);
  }
}

// Admin individual doctor assignment handler
export async function logIndividualAssignmentAdmin({
  assignedBy = "Unknown Admin",
  assignedDoctor = "Unknown Doctor",
  patientId,
  patientName = "Unknown Patient",
  success = false,
  failureReason = "",
  isUnassign = false,
  previousDoctors = [],
}) {
  try {
    const logRef = dbRef(db, "audit_logs/UserManagement/Admin_logs/Doctor_Assignment_Admin");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent || "Unknown";
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success
        ? isUnassign 
          ? "Doctor unassigned from patient by admin"
          : "Doctor assigned to patient by admin"
        : "Individual assignment failed by admin",
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown",
    };

    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}

    // Encrypt patient ID if it exists
    const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
    const encryptedId = patientId 
      ? CryptoJS.AES.encrypt(patientId.toString(), secretKey).toString()
      : "Unknown";
    
    const entry = {
      event_type: success 
        ? isUnassign ? "doctor_unassigned_admin" : "doctor_assigned_admin"
        : "individual_assignment_failed_admin",
      assigned_by: assignedBy || "Unknown Admin",
      assigned_doctor: assignedDoctor || "Unknown Doctor",
      patient_id_encrypted: encryptedId,
      patient_name: patientName || "Unknown Patient",
      success: Boolean(success),
      timestamp,
      details,
      previous_doctors: previousDoctors.filter(doc => doc),
      ...((!success && failureReason) && { failure_reason: failureReason }),
    };
    
    await push(logRef, entry);
    console.log("Admin individual assignment audit log written.");
  } catch (err) {
    console.error("Failed to write admin individual assignment audit log:", err);
  }
} 

//deepaaudit logs - Function to log report share events by admin
export async function logShareEventAdmin({
  adminName,
  patientId,
  patientName,
  action = "share", // "share", "copy", or "whatsapp"
  reportUrl = "",
  success = true,
  failureReason = ""
}) {
  try {
    //deepaaudit logs - Store logs in share_report_admin node
    const logRef = dbRef(db, "audit_logs/UserManagement/Admin_logs/share_report_admin");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success
        ? `Report ${action} by admin`
        : `Report ${action} failed by admin`,
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown"
    };

    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}

    //deepaaudit logs - Encrypt patient ID for audit log
    const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
    const encryptedId = patientId 
      ? CryptoJS.AES.encrypt(patientId.toString(), secretKey).toString()
      : "Unknown";

    //deepaaudit logs - Create audit log entry with encrypted patient ID
    const entry = {
      event_type: success ? `report_share_${action}_admin` : `report_share_${action}_failed_admin`,
      admin_name: adminName,
      patient_id_encrypted: encryptedId,
      patient_name: patientName,
      report_url: reportUrl,
      success,
      timestamp,
      details,
      ...(!success && { failure_reason: failureReason })
    };

    await push(logRef, entry);
    console.log("Admin share event logged successfully");
  } catch (err) {
    console.error("Failed to write admin share event audit log:", err);
  }
}

//deepaaudit logs - Function to log report download events by admin
export async function logDownloadReportAdmin({
  adminName,
  patientId,
  patientName,
  reportUrl = "",
  success = true,
  failureReason = ""
}) {
  try {
    //deepaaudit logs - Store logs in download_report_admin node
    const logRef = dbRef(db, "audit_logs/UserManagement/Admin_logs/download_report_admin");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success
        ? "Report downloaded by admin"
        : "Report download failed by admin",
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown"
    };

    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}

    //deepaaudit logs - Encrypt patient ID and report_url for audit log
    const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
    const encryptedId = patientId 
      ? CryptoJS.AES.encrypt(patientId.toString(), secretKey).toString()
      : "Unknown";
    const encryptedReportUrl = reportUrl ? CryptoJS.AES.encrypt(reportUrl, secretKey).toString() : "";

    //deepaaudit logs - Create audit log entry with encrypted patient ID and report_url
    const entry = {
      event_type: success ? "report_download_admin" : "report_download_failed_admin",
      admin_name: adminName,
      patient_id_encrypted: encryptedId,
      patient_name: patientName,
      report_url: encryptedReportUrl,
      success,
      timestamp,
      details,
      ...(!success && { failure_reason: failureReason })
    };

    await push(logRef, entry);
    console.log("Admin download event logged successfully");
  } catch (err) {
    console.error("Failed to write admin download event audit log:", err);
  }
}

//deepaaudit logs - Function to log patient deletion events by admin
export async function logDeletePatientAdmin({
  adminName,
  patientId,
  patientName,
  success = true,
  failureReason = ""
}) {
  try {
    //deepaaudit logs - Store logs in delete_patient_admin node
    const logRef = dbRef(db, "audit_logs/UserManagement/Admin_logs/delete_patient_admin");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success
        ? "Patient deleted by admin"
        : "Patient deletion failed by admin",
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown"
    };

    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}

    //deepaaudit logs - Encrypt patient ID for audit log
    const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
    const encryptedId = patientId 
      ? CryptoJS.AES.encrypt(patientId.toString(), secretKey).toString()
      : "Unknown";

    //deepaaudit logs - Create audit log entry with encrypted patient ID
    const entry = {
      event_type: success ? "patient_deleted_admin" : "patient_deletion_failed_admin",
      admin_name: adminName,
      patient_id_encrypted: encryptedId,
      patient_name: patientName,
      success,
      timestamp,
      details,
      ...(!success && { failure_reason: failureReason })
    };

    await push(logRef, entry);
    console.log("Admin delete patient event logged successfully");
  } catch (err) {
    console.error("Failed to write admin delete patient event audit log:", err);
  }
}

//deepaaudit logs - Function to log data export events by admin
export async function logExportDataAdmin({
  adminName,
  startDate,
  endDate,
  exportType = "csv", // can be "csv", "excel" etc.
  recordCount = 0,
  success = true,
  failureReason = ""
}) {
  try {
    //deepaaudit logs - Store logs in exportdata_admin node
    const logRef = dbRef(db, "audit_logs/UserManagement/Admin_logs/exportdata_admin");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success
        ? `Data exported as ${exportType.toUpperCase()} by admin`
        : `Data export as ${exportType.toUpperCase()} failed by admin`,
      date_range: `${startDate || 'All'} to ${endDate || 'All'}`,
      records_exported: recordCount,
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown"
    };

    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}

    //deepaaudit logs - Create audit log entry for export
    const entry = {
      event_type: success ? "data_export_admin" : "data_export_failed_admin",
      admin_name: adminName,
      export_type: exportType,
      start_date: startDate || "All",
      end_date: endDate || "All",
      record_count: recordCount,
      success,
      timestamp,
      details,
      ...(!success && { failure_reason: failureReason })
    };

    await push(logRef, entry);
    console.log("Admin export data event logged successfully");
  } catch (err) {
    console.error("Failed to write admin export data event audit log:", err);
  }
}

//deepaaudit logs - Function to log report view events by admin
export async function logViewReportAdmin({
  adminName,
  patientId,
  patientName,
  reportUrl = "",
  success = true,
  failureReason = ""
}) {
  try {
    //deepaaudit logs - Store logs in view_report_admin node
    const logRef = dbRef(db, "audit_logs/UserManagement/Admin_logs/view_report_admin");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success
        ? "Report viewed by admin"
        : "Report view failed by admin",
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown"
    };

    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}

    //deepaaudit logs - Encrypt patient ID and report_url for audit log
    const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
    const encryptedId = patientId 
      ? CryptoJS.AES.encrypt(patientId.toString(), secretKey).toString()
      : "Unknown";
    const encryptedReportUrl = reportUrl ? CryptoJS.AES.encrypt(reportUrl, secretKey).toString() : "";

    //deepaaudit logs - Create audit log entry with encrypted patient ID and report_url
    const entry = {
      event_type: success ? "report_viewed_admin" : "report_view_failed_admin",
      admin_name: adminName,
      patient_id_encrypted: encryptedId,
      patient_name: patientName,
      report_url: encryptedReportUrl,
      success,
      timestamp,
      details,
      ...(!success && { failure_reason: failureReason })
    };

    await push(logRef, entry);
    console.log("Admin view report event logged successfully");
  } catch (err) {
    console.error("Failed to write admin view report event audit log:", err);
  }
}

//deepaforaudit logs - Report finalization audit logging function
export async function logReportFinalizeAdmin({
  adminName,
  patientId,
  patientName,
  assignedDoctor,
  success = true,
  failureReason = "",
  isUnassign = false,
  previousDoctors = []
}) {
  try {
    //deepaforaudit logs - Store logs in Report_finalize_admin node
    const logRef = dbRef(db, "audit_logs/UserManagement/Admin_logs/Report_finalize_admin");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success
        ? isUnassign 
          ? "Report finalization doctor unassigned by admin"
          : "Report finalization doctor assigned by admin"
        : "Report finalization failed by admin",
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown"
    };

    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}

    //deepaforaudit logs - Encrypt patient ID for audit log
    const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
    const encryptedId = patientId 
      ? CryptoJS.AES.encrypt(patientId.toString(), secretKey).toString()
      : "Unknown";

    //deepaforaudit logs - Create audit log entry with proper field names for assigned/unassigned doctors
    const entry = {
      event_type: success 
        ? isUnassign ? "report_finalize_unassign_admin" : "report_finalize_assign_admin"
        : "report_finalize_failed_admin",
      admin_name: adminName,
      patient_id_encrypted: encryptedId,
      patient_name: patientName,
      // Use different field names based on assignment type
      ...(isUnassign 
        ? { unassigned_doctor: assignedDoctor }
        : { assigned_doctor: assignedDoctor }
      ),
      success,
      timestamp,
      details,
      ...(previousDoctors.length > 0 && { previous_doctors: previousDoctors }),
      ...(!success && { failure_reason: failureReason })
    };

    await push(logRef, entry);
    console.log("Admin report finalization logged successfully");
  } catch (err) {
    console.error("Failed to write admin report finalization audit log:", err);
  }
}

//deepaaudit logs - Function to log prescription view events by admin
export const logViewPrescriptionAdmin = async ({
  adminName,
  patientId,
  patientName,
  prescriptionUrl,
  success,
  failureReason = ""
}) => {
  try {
    //deepaaudit logs - Store logs in prescription_view_admin node
    const logRef = dbRef(db, "audit_logs/UserManagement/Admin_logs/prescription_view_admin");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success ? "Prescription viewed by admin" : "Prescription view failed by admin",
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown"
    };

    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}

    //deepaaudit logs - Encrypt prescription_url for HIPAA compliance
    const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
    const encryptedPrescriptionUrl = prescriptionUrl ? CryptoJS.AES.encrypt(prescriptionUrl, secretKey).toString() : "";

    //deepaaudit logs - Create audit log entry
    const entry = {
      event_type: success ? "prescription_view_admin" : "prescription_view_failed_admin",
      admin_name: adminName,
      patient_id: patientId,
      patient_name: patientName,
      prescription_url: encryptedPrescriptionUrl,
      success,
      timestamp,
      details,
      ...(!success && { failure_reason: failureReason })
    };

    await push(logRef, entry);
    console.log("Admin prescription view event logged successfully");
  } catch (err) {
    console.error("Failed to write admin prescription view audit log:", err);
  }
};

//deepaaudit logs - Function to log 3D view events by admin
export const logView3DAdmin = async ({
  adminName,
  patientId,
  patientName,
  modelUrl,
  success,
  failureReason = ""
}) => {
  try {
    //deepaaudit logs - Store logs in 3d_view_admin node
    const logRef = dbRef(db, "audit_logs/UserManagement/Admin_logs/3d_view_admin");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success ? "3D model viewed by admin" : "3D view failed by admin",
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown"
    };

    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}

    //deepaaudit logs - Encrypt model_url for HIPAA compliance
    const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
    const encryptedModelUrl = modelUrl ? CryptoJS.AES.encrypt(modelUrl, secretKey).toString() : "";

    //deepaaudit logs - Create audit log entry
    const entry = {
      event_type: success ? "3d_view_admin" : "3d_view_failed_admin",
      admin_name: adminName,
      patient_id: patientId,
      patient_name: patientName,
      model_url: encryptedModelUrl,
      success,
      timestamp,
      details,
      ...(!success && { failure_reason: failureReason })
    };

    await push(logRef, entry);
    console.log("Admin 3D view event logged successfully");
  } catch (err) {
    console.error("Failed to write admin 3D view audit log:", err);
  }
};

//deepaaudit logs - Function to log DICOM view events by admin
export const logViewDicomAdmin = async ({
  adminName,
  patientId,
  patientName,
  dicomUrl,
  success,
  failureReason = ""
}) => {
  try {
    //deepaaudit logs - Store logs in patientdicomview_admin node
    const logRef = dbRef(db, "audit_logs/UserManagement/Admin_logs/patientdicomview_admin");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success ? "DICOM viewed by admin" : "DICOM view failed by admin",
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown"
    };

    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}

    //deepaaudit logs - Encrypt dicom_url for HIPAA compliance
    const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
    const encryptedDicomUrl = dicomUrl ? CryptoJS.AES.encrypt(dicomUrl, secretKey).toString() : "";

    //deepaaudit logs - Create audit log entry
    const entry = {
      event_type: success ? "patientdicomview_admin" : "patientdicomview_failed_admin",
      admin_name: adminName,
      patient_id: patientId,
      patient_name: patientName,
      dicom_url: encryptedDicomUrl,
      success,
      timestamp,
      details,
      ...(!success && { failure_reason: failureReason })
    };

    await push(logRef, entry);
    console.log("Admin DICOM view event logged successfully");
  } catch (err) {
    console.error("Failed to write admin DICOM view audit log:", err);
  }
};

//deepaaudit logs - Function to log patient medical record view events by admin
export const logViewPatientRecordAdmin = async ({
  adminName,
  patientId,
  patientName,
  recordUrl,
  success,
  failureReason = ""
}) => {
  try {
    //deepaaudit logs - Store logs in patient_record_view_admin node
    const logRef = dbRef(db, "audit_logs/UserManagement/Admin_logs/patient_record_view_admin");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success ? "Patient medical record viewed by admin" : "Patient medical record view failed by admin",
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown"
    };

    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}

    //deepaaudit logs - Create audit log entry
    const entry = {
      event_type: success ? "patient_record_view_admin" : "patient_record_view_failed_admin",
      admin_name: adminName,
      patient_id: patientId,
      patient_name: patientName,
      record_url: recordUrl,
      success,
      timestamp,
      details,
      ...(!success && { failure_reason: failureReason })
    };

    await push(logRef, entry);
    console.log("Admin patient medical record view event logged successfully");
  } catch (err) {
    console.error("Failed to write admin patient medical record view audit log:", err);
  }
};